import RefreshIcon from "@mui/icons-material/Refresh";
import { Button, Stack, SxProps, Typography } from "@mui/material";

const ErrorContent = ({
  onRetry,
  sx,
}: {
  onRetry?: () => void;
  sx?: SxProps;
}) => (
  <Stack
    justifyContent="center"
    alignItems="center"
    sx={{
      width: "100%",
      height: "220px",
      bgcolor: "shades.neutral.50",
      borderRadius: "8px",
      ...sx,
    }}
  >
    <Typography variant="bodyPrimaryMed" sx={{ color: "shades.neutral.500" }}>
      Oops, something went wrong.
    </Typography>
    <Button
      color="secondary"
      sx={{ fontSize: "0.875rem" }}
      startIcon={<RefreshIcon />}
      onClick={onRetry}
    >
      Try Again
    </Button>
  </Stack>
);

export default ErrorContent;
